/**
 * API配置文件
 * 统一管理后端接口地址和API路径
 */

// 后端服务器基础地址
// export const BASE_URL = 'https://web.nxhmjk.com';
export const BASE_URL = 'https://www-api.nxhmjk.com';

// API接口路径
export const API = {
  // 轮播图相关接口
  BANNER: '/api/banner_api',
  
  // 药品相关接口
  MEDICINE: '/api/medicine',
  
  // 药品详情接口
  MEDICINE_DETAIL: '/api/medicine/detail',
  
  // 公司简介接口
  ABOUT_US: '/api/about_us_api',
  
  // 药品分类接口
  MEDICINE_CATEGORY: '/api/medicine_category',
  
  // 文章接口
  ARTICLE: '/api/article',
  
  // 药品搜索接口
  MEDICINE_SEARCH: '/api/medicine_api/search',
  
  // 底部信息接口
  FOOTER_INFO: '/api/footer_api',
  
  // 后续可以添加其他接口
  // PRODUCTS: '/api/products',
  // NEWS: '/api/news',
  // ...
};

// 完整的API URL
export const API_URL = {
  BANNER: `${BASE_URL}${API.BANNER}`,
  MEDICINE: `${BASE_URL}${API.MEDICINE}`,
  MEDICINE_DETAIL: `${BASE_URL}${API.MEDICINE_DETAIL}`,
  ABOUT_US: `${BASE_URL}${API.ABOUT_US}`,
  MEDICINE_CATEGORY: `${BASE_URL}${API.MEDICINE_CATEGORY}`,
  ARTICLE: `${BASE_URL}${API.ARTICLE}`,
  MEDICINE_SEARCH: `${BASE_URL}${API.MEDICINE_SEARCH}`,
  FOOTER_INFO: `${BASE_URL}${API.FOOTER_INFO}`,
};

/**
 * 获取药品列表
 * @param {Object} params - 请求参数
 * @param {number} [params.category_id] - 按分类ID筛选药品（可选）
 * @param {string} [params.keywords] - 搜索关键词，可搜索药品名称、生产厂家或批准文号（可选）
 * @param {number} [params.page=1] - 页码，默认为1
 * @param {number} [params.pagesize=15] - 每页显示数量，默认为15
 * @returns {Promise} 返回API响应
 */
export const getMedicines = async (params = {}) => {
  try {
    const axios = (await import('axios')).default;
    const response = await axios.get(API_URL.MEDICINE, { params });
    return response.data;
  } catch (error) {
    console.error('获取药品列表失败:', error);
    throw error;
  }
};

/**
 * 根据分类获取药品
 * @param {number} categoryId - 分类ID
 * @param {number} page - 页码
 * @param {number} pageSize - 每页数量
 * @returns {Promise} 返回API响应
 */
export const getMedicinesByCategory = async (categoryId, page = 1, pageSize = 15) => {
  try {
    const axios = (await import('axios')).default;
    const response = await axios.get(API_URL.MEDICINE, {
      params: {
        category_id: categoryId,
        page,
        pagesize: pageSize
      }
    });
    return response.data;
  } catch (error) {
    console.error('获取分类药品失败:', error);
    throw error;
  }
};

/**
 * 搜索药品
 * @param {string} keywords - 搜索关键词
 * @param {number} [page=1] - 页码
 * @param {number} [pagesize=10] - 每页数量
 * @returns {Promise} 返回API响应
 */
export const searchMedicineAPI = async (keywords, page = 1, pagesize = 10) => {
  if (!keywords) {
    return {
      code: 0,
      msg: '请输入搜索关键词',
      time: String(Math.floor(Date.now() / 1000))
    };
  }
  
  try {
    const axios = (await import('axios')).default;
    const response = await axios.get(API_URL.MEDICINE_SEARCH, {
      params: {
        keywords,
        page,
        pagesize
      }
    });
    return response.data;
  } catch (error) {
    console.error('搜索药品失败:', error);
    throw error;
  }
};

/**
 * 获取公司简介数据
 * @returns {Promise} 返回API响应
 */
export const getAboutUs = async () => {
  try {
    const axios = (await import('axios')).default;
    const response = await axios.get(API_URL.ABOUT_US);
    return response.data;
  } catch (error) {
    console.error('获取公司简介失败:', error);
    throw error;
  }
};

/**
 * 获取药品分类列表
 * @returns {Promise} 返回API响应
 */
export const getMedicineCategories = async () => {
  try {
    const axios = (await import('axios')).default;
    const response = await axios.get(API_URL.MEDICINE_CATEGORY);
    return response.data;
  } catch (error) {
    console.error('获取药品分类失败:', error);
    throw error;
  }
};

/**
 * 获取药品详情
 * @param {number} id - 药品ID
 * @returns {Promise} 返回API响应
 */
export const getMedicineDetail = async (id) => {
  if (!id) {
    return {
      code: 0,
      msg: '参数错误',
      time: String(Math.floor(Date.now() / 1000))
    };
  }
  
  try {
    const axios = (await import('axios')).default;
    const response = await axios.get(API_URL.MEDICINE_DETAIL, {
      params: { id }
    });
    return response.data;
  } catch (error) {
    console.error('获取药品详情失败:', error);
    throw error;
  }
};

/**
 * 获取推荐文章列表
 * @param {Object} params - 参数对象
 * @param {number} [params.page=1] - 页码
 * @param {number} [params.pagesize=10] - 每页数量
 * @returns {Promise} 返回API响应
 */
export const getArticles = async (params = {}) => {
  try {
    const axios = (await import('axios')).default;
    const defaultParams = {
      page: 1,
      pagesize: 10
    };
    
    const requestParams = { ...defaultParams, ...params };
    const response = await axios.get(API_URL.ARTICLE, { params: requestParams });
    return response.data;
  } catch (error) {
    console.error('获取文章列表失败:', error);
    throw error;
  }
};

/**
 * 获取底部信息
 * @returns {Promise} 返回API响应
 */
export const getFooterInfo = async () => {
  try {
    const axios = (await import('axios')).default;
    const response = await axios.get(API_URL.FOOTER_INFO);
    return response.data;
  } catch (error) {
    console.error('获取底部信息失败:', error);
    throw error;
  }
};

export default {
  BASE_URL,
  API,
  API_URL,
  getMedicines,
  getMedicinesByCategory,
  searchMedicineAPI,
  getAboutUs,
  getMedicineCategories,
  getMedicineDetail,
  getArticles,
  getFooterInfo
}; 